import { render, staticRenderFns } from "./modal-register.vue?vue&type=template&id=45c6d978&"
import script from "./modal-register.vue?vue&type=script&lang=js&"
export * from "./modal-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports